export default __webpack_public_path__ + "static/media/31.1d2eafcd.mp3";